export enum UserRole {
  OFFICER = 'officer',
  ADMIN = 'admin',
  VIEWER = 'viewer'
}

export interface User {
  id: string;
  email: string;
  fullName: string;
  badgeNumber?: string;
  role: UserRole;
  profileImageUrl?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Officer {
  id: string;
  email: string;
  fullName: string;
  badgeNumber: string;
  department?: string;
  profileImageUrl?: string;
  isOnline: boolean;
  isAvailable: boolean;
  lastSeen?: Date;
  lastLocationUpdate?: Date;
  latitude?: number;
  longitude?: number;
  createdAt: Date;
  updatedAt: Date;
}

export enum TicketStatus {
  ISSUED = 'issued',
  PAID = 'paid',
  WARRANT_ISSUED = 'warrantIssued'
}

export enum ViolationType {
  NO_INSURANCE = 'No Insurance',
  NO_LICENCE = "No Driver's Licence",
  EXPIRED_LICENCE = 'Expired Licence',
  UNREGISTERED = 'Unregistered Vehicle',
  FAIL_TO_INSURE = 'Fail to Insure Vehicle',
  SPEEDING = 'Speeding',
  TINT_VIOLATION = 'Tint Violation',
  LOUD_MUFFLER = 'Loud Muffler',
  SEAT_BELT = 'Seat-belt / Helmet',
  DISOBEY_SIGN = 'Disobey Sign',
  OTHER = 'Other'
}

export interface TrafficTicket {
  id: string;
  ticketCode?: string;
  violatorName: string;
  address: string;
  offenceType: ViolationType;
  customOffence?: string;
  fineAmount?: number;
  status: TicketStatus;
  officerId: string;
  officerName?: string;
  officerBadgeNumber?: string;
  location: {
    latitude: number;
    longitude: number;
  };
  createdAt: Date;
  paymentDate?: Date;
  island?: string;
  parish?: string;
  licenceNumber?: string;
  licensePlate?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleColor?: string;
  vehicleYear?: string;
  violatorDOB?: Date;
  offenceTime?: Date;
  vehiclePhotoUrl?: string;
  driverLicencePhotoUrl?: string;
}

export enum AccidentStatus {
  REPORTED = 'Reported',
  UNDER_INVESTIGATION = 'Under Investigation',
  RESOLVED = 'Resolved',
  CLOSED = 'Closed'
}

export interface Accident {
  id: string;
  accidentNumber: string;
  date: Date;
  time: Date;
  status: AccidentStatus;
  location: string;
  parish: string;
  island: string;
  latitude: number;
  longitude: number;
  reportingOfficerId: string;
  reportingOfficerName: string;
  badgeNumber: string;
  reportNumber: string;
  parties: any[];
  weatherConditions: string;
  roadConditions: string;
  lightConditions: string;
  accidentType: string;
  narrative: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface DashboardStats {
  totalTickets: number;
  totalRevenue: number;
  activeOfficers: number;
  onlineOfficers: number;
  totalAccidents: number;
  unpaidTickets: number;
  paidTickets: number;
}

export interface OfficerPerformance {
  officerId: string;
  officerName: string;
  ticketCount: number;
  totalRevenue: number;
  paymentRate: number;
}

export interface ViolationTypeStat {
  type: string;
  count: number;
  totalRevenue: number;
  averageFine: number;
}

export interface HazardAlert {
  id: string;
  title: string;
  description: string;
  hazardType: 'roadwork' | 'accident' | 'flooding' | 'debris' | 'closure' | 'construction' | 'other';
  coordinate: {
    latitude: number;
    longitude: number;
  };
  island: string;
  severity: 'low' | 'medium' | 'high' | 'urgent';
  isActive: boolean;
  createdAt: any;
}
